import { memo } from "react";
import { Row, Col, Table } from "react-bootstrap";

import Presence from "typings/Presence";

import printDate from "utils/printDate";

type PresencesListProps = {
  presences: Presence[];
};

const PresencesList = ({ presences }: PresencesListProps) => {
  return (
    <>
      {presences.length > 0 && (
        <Row md={2} className="justify-content-md-center my-3">
          <Col>
            <h5>Total presences: {presences.length}</h5>
            <Table striped bordered hover responsive="md">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Username</th>
                  <th>Entrance</th>
                  <th>Exit</th>
                </tr>
              </thead>
              <tbody>
                {presences.map((presence, index) => (
                  <tr key={index}>
                    <td>{presence.id}</td>
                    <td>{presence.username}</td>
                    <td>{printDate(presence.inDate.toString())}</td>
                    <td>
                      {presence.outDate
                        ? printDate(presence.outDate.toString())
                        : "Still inside"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      )}
    </>
  );
};

export default memo(PresencesList);
